import React, { useState } from 'react';
import { Building, ArrowLeft, ArrowRight } from 'lucide-react';

interface BuildingDetailsStepProps {
  value: {
    buildingDetails: {
      units: number;
      commonAreas: boolean;
    };
  };
  onChange: (field: string, value: any) => void;
  onNext: () => void;
  onBack: () => void;
}

export const BuildingDetailsStep: React.FC<BuildingDetailsStepProps> = ({
  value,
  onChange,
  onNext,
  onBack
}) => {
  const [isFocused, setIsFocused] = useState(false);

  const handleDetailsChange = (field: keyof typeof value.buildingDetails, newValue: any) => {
    onChange('buildingDetails', {
      ...value.buildingDetails,
      [field]: newValue
    });
  };

  const handleFocus = () => {
    setIsFocused(true);
    handleDetailsChange('units', '');
  };

  return (
    <div className="space-y-6">
      {/* Boutons de navigation compacts en haut */}
      <div className="flex justify-between items-center pb-4 border-b border-neutral-200">
        <h2 className="text-base font-semibold text-primary">Détails de l'immeuble</h2>
        <div className="flex items-center gap-2 ml-4">
          {onBack && (
            <button
              type="button"
              onClick={onBack}
              className="px-3 py-2 text-sm font-medium text-neutral-700 bg-white border border-neutral-300 rounded-lg hover:bg-neutral-50 transition-colors flex items-center gap-1"
            >
              <ArrowLeft className="h-4 w-4" />
              Précédent
            </button>
          )}
          <button
            type="button"
            onClick={onNext}
            disabled={!value.buildingDetails.units || value.buildingDetails.units < 1}
            className={`px-3 py-2 text-sm font-medium text-white bg-primary rounded-lg hover:bg-primary-dark transition-colors flex items-center gap-1 ${
              !value.buildingDetails.units || value.buildingDetails.units < 1 ? 'opacity-50 cursor-not-allowed' : ''
            }`}
          >
            Suivant
            <ArrowRight className="h-4 w-4" />
          </button>
        </div>
      </div>
      
      <div className="card">
        <div className="flex items-center mb-4">
          <Building className="h-6 w-6 text-primary mr-3" />
          <span className="font-medium text-neutral-800">Nombre de logements</span>
        </div>
        <input
          type="number"
          value={isFocused ? value.buildingDetails.units || '' : value.buildingDetails.units || 1}
          onChange={(e) => handleDetailsChange('units', parseInt(e.target.value) || '')}
          onFocus={handleFocus}
          onBlur={() => setIsFocused(false)}
          min="1"
          className="input w-full"
          placeholder="Nombre de logements dans l'immeuble"
        />
      </div>

      <div className="card">
        <label className="flex items-center space-x-3">
          <input
            type="checkbox"
            checked={value.buildingDetails.commonAreas}
            onChange={(e) => handleDetailsChange('commonAreas', e.target.checked)}
            className="h-4 w-4 rounded border-neutral-300 text-primary focus:ring-primary"
          />
          <span className="text-neutral-700">Inclure la rénovation des parties communes</span>
        </label>
      </div>
    </div>
  );
};

export default BuildingDetailsStep;